/**
 * 手机号校验
 * @param number
 * @returns {boolean}
 */
function isPhoneNumber (number) {
  let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
  return reg.test(number)
}
function isHphm (data) {
  let reg = /(^[A-Z]{2}[\u4e00-\u9fa5a-zA-Z0-9·•]*$)|(^[\u4e00-\u9fa5a-zA-Z0-9·•]{6}[领使港澳军海空总炮武试超]$)|(^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z]([A-HJ-NP-Z0-9]{6}))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$)|(^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}(([A-HJ-Z]{1}[A-HJ-NP-Z0-9]{6})|([A-HJ-NP-Z]{1}(([A-HJ-NP-Z0-9]{2}[0-9]{4})|([0-9]{6})))|([A-HJ-Z]{1}[A-D0-9]{1}[0-9]{3}警)))$)|(^([0-9]{6}使)$)|(^((([沪粤川云桂鄂陕蒙藏黑辽渝]{1}A)|鲁B|闽D|蒙E|蒙H)[0-9]{4}领)$)|(^(WJ[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼·•]?[0-9]{4}[TDSHBXJ0-9]{1})$)|(^([VKHBSLJNGCE]{1}[A-DJ-PR-TVY]{1}[0-9]{5})$)|([*?]+)/
  return reg.test(data)
}
function validForm (type, data) {
  if (type === 'phone') {
    return isPhoneNumber(data)
  } else if (type === 'hphm') {
    return isHphm(data)
  }
}
export {
  validForm
}



// WEBPACK FOOTER //
// ./src/utils/validData.js